/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentsDeleteAgent } from "../../funcs/agentsDeleteAgent.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteAgentRequest$inboundSchema,
};

export const tool$agentsDeleteAgent: ToolDefinition<typeof args> = {
  name: "agents-delete-agent",
  description: `Delete an agent`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentsDeleteAgent(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
